// extracted by mini-css-extract-plugin
module.exports = {"registrationContainer":"RegistrationRoute_registrationContainer__2Ivo-"};